import { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../components/img/logo.jpeg";
import { baseurl } from "../Baseurl";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Extract email and token from query params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    const tokenParam = params.get("token");

    if (!emailParam || !tokenParam) {
      Swal.fire({
        icon: "error",
        title: "Invalid Link",
        text: "Missing token or email in the URL.",
      });
      return;
    }

    setEmail(emailParam);
    setToken(tokenParam);
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "All fields required",
        text: "Please enter both password fields.",
      });
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Passwords do not match",
        text: "Please make sure both passwords are identical.",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${baseurl}resetPassword`, {
        email,
        token,
        password,
      });

      Swal.fire({
        icon: "success",
        title: "Password Reset Successfully",
        text: response.data.message || "You can now log in with your new password.",
      });

      navigate("/"); // Redirect to login
    } catch (error) {
      console.error("Reset password error:", error.response?.data?.message || error.message);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error.response?.data?.message || "Unable to reset password. Try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <div>
          <div className="text-center mb-1">
            <img src={logo} className="img-fluid logo" alt="Bosplan Logo" />
          </div>

          <div className="mb-1 text-center">
            <h3 className="text-dark">Reset Password</h3>
            <p className="text-muted">Enter your new password below</p>
          </div>

          <div className="card p-4" style={{ maxWidth: "400px", width: "100%" }}>
            <form onSubmit={handleSubmit}>
              <div className="mb-3 text-start">
                <label htmlFor="password" className="form-label">
                  New Password <span className="text-danger">*</span>
                </label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3 text-start">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password <span className="text-danger">*</span>
                </label>
                <input
                  type="password"
                  id="confirmPassword"
                  className="form-control"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>

              <div className="mt-3">
                {loading ? (
                  <div className="spinner-container text-center">
                    <div className="spinner-border text-primary" role="status"></div>
                  </div>
                ) : (
                  <button type="submit" className="btn submitbtnn w-100">
                    Reset Password
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
